import React from 'react';
import history from '../../history';
import Dropzone from 'react-dropzone-uploader'
import * as XLSX from 'xlsx';
import { connect } from 'react-redux';
import SubHeader from './SubHeader';
import api from "../../api/api";
import uri from "../../variables/uri";
import FormSelect from '../forms/FormSelect';
import AlertModal from '../modals/AlertModal';
import { setLoading } from '../../actions/authAction';

class UploadDoaNewBook extends React.Component {
    state = {
        isOpenMessage: false,
        type:1,
        message: "",
        text: "",
        bookName: '-- Please select book --',
        bookList: ['-- Please select book --'],
        bookArr: '-- Please select book --',
        permissionName: '',
        permissionList: ['-- Please select permission --'],
        permissionArr: '-- Please select permission --',
        date: new Date().toLocaleDateString()
    }

    componentDidMount = async () => {
        if (!this.props.isAuthen || (!this.props.auth.isAdmin)) {
            history.push(`/home/${localStorage.getItem('username')}`)
        } 
        const bookList = ['-- Please select book --'];
        const permissionList = ['-- Please select permission --'];
        //if (this.props.bookList.length === 0 || this.props.permissionList.length === 0) {
            const responseBook = await api.get(`${uri.GET_BOOK_LIST}`);
            const responsePermission = await api.get(`${uri.GET_MASTER_PERMISSION_GROUP}`);
            if (responseBook.status === 200 && responsePermission.status === 200) {
                
                responseBook.data.forEach(element => {
                    bookList.push(element.BookName);
                });
                responsePermission.data.forEach(element => {
                    permissionList.push(element.PermissionGroupName);
                });
                this.setState({ bookList: bookList, bookArr: responseBook.data, permissionList: permissionList, permissionArr: responsePermission.data });
            }
        // } else {
        //     this.props.bookList.forEach(element => {
        //         bookList.push(element.BookName);
        //     });
        //     this.props.permissionList.forEach(element => {
        //         permissionList.push(element.PermissionGroupName);
        //     })
        //     this.setState({ bookList, bookArr: this.props.bookList, permissionList, permissionArr: this.props.permissionList });
        // }
    }

    // called every time a file's `status` changes
    handleChangeStatus = ({ meta, file }, status) => { console.log(status, meta, file) }

    // receives array of files that are done uploading when submit button is clicked
    handleSubmit = (files, allFiles) => {
        this.props.setLoading(true);
        var file = allFiles[0].file;
        var reader = new FileReader();
        reader.readAsBinaryString(file, "UTF-8")
        reader.onload = async () => {
            try {
                var data = reader.result;
                let readedData = XLSX.read(data, { type: 'binary' });
                const wsname = readedData.SheetNames[0];
                const ws = readedData.Sheets[wsname];

                const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
                const excelArr = dataParse.filter((item, i) => item.length > 0 && i !== 0);

                const arrObj = [], arrReq = [];
                excelArr.forEach(element => {
                    arrObj.push({
                        subjectId: (element[0] !== undefined && element[0] !== "") ? element[0] : '-',
                        subjectType: (element[1] !== undefined && element[1] !== "") ? element[1] : '-',
                        topicNo: (element[2] !== undefined && element[2] !== "") ? element[2] : '-',
                        topicTitle: (element[3] !== undefined && element[3] !== "") ? element[3] : '-',
                        conditionTitle: (element[4] !== undefined && element[4] !== "") ? element[4] : '-',
                        type: (element[5] !== undefined && element[5] !== "") ? element[5] : '-',
                        operation: (element[6] !== undefined && element[6] !== "") ? element[6] : '-',
                        value: (element[7] !== undefined && element[7] !== "") ? element[5] === "Amount" ? element[7].toString().replace(/,/g, '') : element[7] : '-',
                        approvalLevel: (element[8] !== undefined && element[8] !== "") ? element[8] : '-',
                        approvalText: (element[9] !== undefined && element[9] !== "") ? element[9] : '-',
                        signLevel: (element[10] !== undefined && element[10] !== "") ? element[10] : '-',
                        signText: (element[11] !== undefined && element[11] !== "") ? element[11] : '-',
                        reportLevel: (element[12] !== undefined && element[12] !== "") ? element[12] : '-',
                        reportText: (element[13] !== undefined && element[13] !== "") ? element[13] : '-',
                        remark: (element[14] !== undefined && element[14] !== "") ? element[14] : '-',
                        comment: (element[15] !== undefined && element[15] !== "") ? element[15] : '-'
                    });
                });

                arrObj.forEach((element, i) => {
                    if (i === 0) {
                        arrReq.push({
                            subjectId: element.subjectId,
                            subjectType: element.subjectType,
                            topicNo: element.topicNo,
                            topicTitle: element.topicTitle,
                            conditionTitle: [],
                            type: [],
                            operation: [],
                            value: [],
                            approvalLevel: [],
                            approvalText: [],
                            signLevel: [],
                            signText: [],
                            reportLevel: [],
                            reportText: [],
                            remark: [],
                            comment: []
                        });
                    }

                    let obj = {}, index = -1, assignObj = false;
                    arrReq.forEach((item, i) => {
                        if (element.subjectId === item.subjectId && element.topicNo === item.topicNo && element.subjectType === item.subjectType) {
                            index = i;
                        }
                    });

                    if (index !== -1) {
                        arrReq[index].conditionTitle.push(element.conditionTitle);
                        arrReq[index].type.push(element.type);
                        arrReq[index].operation.push(element.operation);
                        arrReq[index].value.push(element.value);
                        arrReq[index].approvalLevel.push(element.approvalLevel);
                        arrReq[index].approvalText.push(element.approvalText);
                        arrReq[index].signLevel.push(element.signLevel);
                        arrReq[index].signText.push(element.signText);
                        arrReq[index].reportLevel.push(element.reportLevel);
                        arrReq[index].reportText.push(element.reportText);
                        arrReq[index].remark.push(element.remark);
                        arrReq[index].comment.push(element.comment);
                    } else {
                        assignObj = true;
                        obj = {
                            subjectId: element.subjectId,
                            subjectType: element.subjectType,
                            topicNo: element.topicNo,
                            topicTitle: element.topicTitle,
                            conditionTitle: [element.conditionTitle],
                            type: [element.type],
                            operation: [element.operation],
                            value: [element.value],
                            approvalLevel: [element.approvalLevel],
                            approvalText: [element.approvalText],
                            signLevel: [element.signLevel],
                            signText: [element.signText],
                            reportLevel: [element.reportLevel],
                            reportText: [element.reportText],
                            remark: [element.remark],
                            comment: [element.comment]
                        }
                    }

                    if (assignObj) {
                        arrReq.push(obj);
                    }
                });

                const book = this.state.bookArr.find(item => item.BookName === this.state.bookName);
                const found = this.state.permissionArr.find(item => item.PermissionGroupName === this.state.permissionName);
                console.log(arrReq)
                const response = await api.post(`${uri.POST_UPLOAD_DOA}`, {
                    BookCode: book.BookCode,
                    BookReleaseId: book.BookReleaseId,
                    DoaList: arrReq,
                    PermissionGroupID: found.PermissionGroupID,
                    ActiveDate: this.state.date,
                    UserId: localStorage.getItem('username')
                });

                if (response.status === 200) {
                    this.setState({isOpenMessage: true, message:'Uploaded Successfully.', type:1})
                    //this.props.setAlert({ isAlert: true, title: 'Uploaded Successfully' })
                }
            } catch (ex) {
                console.log(ex)
            }
            this.props.setLoading(false);
        };

        console.log(files.map(f => f.meta));
        allFiles.forEach(f => f.remove());
    }

    onBookNameChange = (bookName) => {
        this.setState({ bookName });
    }

    onPermissionNameChange = (permissionName) => {
        this.setState({ permissionName });
    }

    onDateChange = (date) => {
        this.setState({ date });
    }

    onClose = () =>{
        this.setState({isOpenMessage: false});
      }

    render() {
        return (
            <div className="flex-v home">
                <SubHeader text={`Upload all in book`} />
                <div className="card">
                    <div className="card-content p-24">
                        <FormSelect
                            name="Book"
                            value={this.state.bookName}
                            onValueChange={this.onBookNameChange}
                            options={this.state.bookList}
                        /> <br />
                        {/* <FormDate
                            name="Active Date"
                            value={this.state.date}
                            onValueChange={this.onDateChange}
                        /><br /> */}
                          <FormSelect
                            name="Permission"
                            value={this.state.permissionName}
                            onValueChange={this.onPermissionNameChange}
                            options={this.state.permissionList}
                        /> <br />
                        <span className="mt-24"></span>
                        <Dropzone
                            onChangeStatus={this.handleChangeStatus}
                            onSubmit={this.handleSubmit}
                            accept=".csv,.xls,.xlsx"
                            maxFiles={1}
                            multiple={false}
                            inputContent="Drag File or Click to Browse"
                        />
                    </div>
                </div>
                <AlertModal isOpen={this.state.isOpenMessage} message={this.state.message} onClose={this.onClose} type={this.state.type} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        bookList: state.doa.bookList,
        permissionList: state.doa.permissionList,
        isAuthen: state.auth.isAuthen,
        auth: state.auth,
    }
}
export default connect(mapStateToProps, {
    setLoading
})(UploadDoaNewBook)